import { render, staticRenderFns } from "./DocumentacionPage.vue?vue&type=template&id=a0d7b0f6&scoped=true"
import script from "./DocumentacionPage.vue?vue&type=script&lang=ts"
export * from "./DocumentacionPage.vue?vue&type=script&lang=ts"
import style0 from "./DocumentacionPage.vue?vue&type=style&index=0&id=a0d7b0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d7b0f6",
  null
  
)

export default component.exports